import type { HeroProps } from '@/components/lemonadeGoesGlobal/Hero';
import { sharedConfig } from '@/pageConfig/shared';
import og from '@/static/assets/lemonade_goes_global/og.png';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/LemonadeGoesGlobal/lemonadeGoesGlobal__en-US.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

const webpageJsonld = {
  '@context': 'https://schema.org/',
  '@type': 'WebPage',
  name: 'Lemonade Is Coming',
  image:
    'https://www.lemonade.com/assets/lemonade-goes-global-og-e71b56e038295278da32f118dbb6c3c15be3d11e7db48155cfb35c705afb6b95.png',
  description: `Follow Lemonade's progress and see when we arrive in your state as we launch across the US.`,
};

export interface Config extends BasePageConfig {
  hero: HeroProps;
}

export const config: Config = {
  layout: { ...sharedConfig['en-US'].layout },
  seo: {
    title: "Where's Lemonade Available in the US and Europe? | Lemonade",
    metaTitle: "Where's Lemonade Available in the US and Europe? | Lemonade",
    description:
      "Lemonade is a new kind of insurance company powered by tech and driven by social good. We offer renters, homeowners, pet, and term life insurance throughout the United States, as well as home policies in Germany, the Netherlands, and France :sparkles:  Explore for more info on what's available where, or just enter your email and we'll drop you a line when we get there!",
    jsonld: [webpageJsonld],
    ogImage: og.src,
  },
  hero: {
    title: 'Be the First to Know!',
    subtitle: `We’re rolling out across the <a href="https://www.lemonade.com/blog/lemonade-expansion-united-states/">US</a> and Europe.\nLeave your email and we’ll let you know when we’re headed your way`,
  },
  MDXContent: content as DocumentTypes,
};
